import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
  makeRequest('put', `/api/users/${id}/update_user`, payload);



// WEBPACK FOOTER //
// ./src/app/services/account/updateUser.js